import closeIcon from '_assets/img/icons/svg/cross-icon.svg';
import whiteCloseIcon from '_assets/img/icons/svg/cross-white.svg';
import { FC } from 'react';
import './CloseButton.scss';

type PropsType = {
    onClose: () => void;
    iconColor?: 'white' | 'black';
};

const CloseButton: FC<PropsType> = ({ onClose, iconColor = 'black' }) => {
    return (
        <div className="close-button" onClick={onClose}>
            <img
                src={iconColor === 'white' ? whiteCloseIcon : closeIcon}
                alt="close page"
            />
        </div>
    );
};

export default CloseButton;
